@if (showAdressen || isEigentuemer) {
  <ng-container [ngTemplateOutlet]="templateElement"></ng-container>
} @else {
  <div>
    <span style="font-style: italic">{{ "stammperson-adresssperre" | translate }}</span>
  </div>
}

<ng-template #common>
  <ng-template [ngTemplateOutlet]="adresssperre"></ng-template>
  {{ item.strasse }}
  @if (item.hausnummer) {
    <span> {{ item.hausnummer }}</span>
  }
  @if (item.strasse) {
    <span>,</span>
  }
  @if (item.landCode) {
    <span> {{ item.landCode | uppercase }}-{{ item.plz }} {{ item.ort }}</span>
  }
  @if (!item.landCode) {
    <span> {{ item.plz }} {{ item.ort }}</span>
  }
</ng-template>

<ng-template #button>
  <button
    (click)="copyToClipboard()"
    [ngbTooltip]="getTooltip()"
    class="btn py-0"
    style="background-color: transparent; cursor: pointer"
    type="button">
    <i class="far fa-copy"></i>
  </button>
</ng-template>

<ng-template #typ00>
  @if (link) {
    <cap-link [params]="link.params" [target]="link.target" [tooltipParams]="link.tooltipParams">
      <ng-container [ngTemplateOutlet]="contentTyp00"></ng-container>
    </cap-link>
  } @else {
    {{ item.personAdresseArt | translate }}:
    <ng-container [ngTemplateOutlet]="common"></ng-container>
  }
  <ng-template #contentTyp00>
    {{ item.personAdresseArt | translate }}:
    <ng-container [ngTemplateOutlet]="common"></ng-container>
  </ng-template>
  <ng-container [ngTemplateOutlet]="button"></ng-container>
</ng-template>

<ng-template #typ01>
  @if (link) {
    <cap-link [params]="link.params" [target]="link.target" [tooltipParams]="link.tooltipParams">
      <ng-container [ngTemplateOutlet]="common"></ng-container>
    </cap-link>
  } @else {
    <ng-container [ngTemplateOutlet]="common"></ng-container>
  }
  <ng-container [ngTemplateOutlet]="button"></ng-container>
</ng-template>

<ng-template #adresssperre>
  @if ((hasAdresssperre && hasPermissionAdresse) || (hasAdresssperre && isEigentuemer)) {
    <div class="float-start me-2">
      <span
        [ngbTooltip]="'stammperson-adresssperre-mitBerechtigung' | translate"
        [placement]="'bottom'"
        class="ms-1 fas fa-exclamation-triangle text-warning"></span>
    </div>
  }
</ng-template>
